import { useState, useEffect } from 'react';

const MAX_ITEMS = 6;
const STORAGE_KEY = 'recentlyViewed';

export function useRecentlyViewed() {
  const [recentlyViewed, setRecentlyViewed] =
    useState([]);

  useEffect(() => {
    const stored =
      localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setRecentlyViewed(JSON.parse(stored));
      } catch {
        setRecentlyViewed([]);
      }
    }
  }, []);

  const addToRecentlyViewed = (product) => {
    if (!product?.id) return;
    setRecentlyViewed(prev => {
      const filtered = prev.filter(
        p => p.id !== product.id
      );
      const updated = [
        {
          id: product.id,
          name: product.name,
          brand: product.brand,
          price: product.price,
          image: product.image,
          has_variants: product.has_variants,
          total_variants: product.total_variants || 0,
          is_new: product.is_new,
          is_exclusive: product.is_exclusive,
          category: product.category,
          subcategory: product.subcategory,
          // Stock fields — use what's available
          stock_quantity: product.stock_quantity || 0,
          total_stock: product.total_stock ||
            product.stock_quantity || 0,
          // Price fields — use what's available
          min_price: product.min_price ||
            product.price || 0,
          max_price: product.max_price ||
            product.price || 0,
          finalPrice: product.finalPrice ||
            product.price || 0,
        },
        ...filtered
      ].slice(0, MAX_ITEMS);

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(updated)
      );
      return updated;
    });
  };

  const clearRecentlyViewed = () => {
    localStorage.removeItem(STORAGE_KEY);
    setRecentlyViewed([]);
  };

  return {
    recentlyViewed,
    addToRecentlyViewed,
    clearRecentlyViewed
  };
}
